<template>
    <div class="nsp-entity">
        <div class="d-flex align-items-center">
            <b-button
                size="sm"
                :variant="entity.on ? 'warning' : 'outline-secondary'"
                v-on:click="$emit('toggle', entity)">
                <i class="icon-bulb"></i>
            </b-button>

            <span class="ml-2">{{ entity.name }}</span>

            <b-button
                v-if="entity.type === 'rgb'"
                size="sm"
                variant="link"
                class="ml-auto p-0"
                v-on:click="colorOpen = !colorOpen">{{ $t('NSP_COLOR') }}</b-button>
        </div>

        <div v-if="entity.type === 'dimmer' || entity.type === 'rgb'" class="mt-2">
            <input
                type="range"
                class="nsp-range"
                min="1"
                max="100"
                v-model.number="brightness"
                v-on:change="$emit('dim', { entity, brightness })">
            <span class="small text-muted ml-2">{{ brightness }}%</span>
        </div>

        <div v-if="entity.type === 'rgb' && colorOpen" class="mt-2">
            <colorpicker v-model="color" v-on:input="pushColor"/>
            <select class="form-control form-control-sm mt-2" v-model="effect" v-on:change="pushEffect">
                <option :value="0">{{ $t('RGBEFFECTNONE') }}</option>
                <option :value="1">{{ $t('RGBEFFECTMETEOR') }}</option>
                <option :value="2">{{ $t('RGBEFFECTGRADUAL') }}</option>
                <option :value="3">{{ $t('RGBEFFECTFLASH') }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import { Chrome } from 'vue-color';

export default
{
    name: 'LightRow',
    components:
    {
        colorpicker: Chrome,
    },
    props:
    {
        entity:
        {
            type: Object,
            required: true,
        },
    },
    data()
    {
        const values = this.entity.values || {};

        return {
            colorOpen: false,
            effect: (this.entity.rgbEffect != null) ? parseInt(this.entity.rgbEffect, 10) : 0,
            brightness: (values.brightness !== undefined) ? parseInt(values.brightness, 10) : 100,
            color:
            {
                r: (values.red !== undefined) ? parseInt(values.red, 10) : 255,
                g: (values.green !== undefined) ? parseInt(values.green, 10) : 255,
                b: (values.blue !== undefined) ? parseInt(values.blue, 10) : 255,
                a: 1,
            },
        };
    },
    methods:
    {
        pushColor(value)
        {
            const me = this;

            me.$emit('color', { entity: me.entity, ledcolor: value.rgba });
        },
        pushEffect()
        {
            const me = this;

            me.$emit('effect', { entity: me.entity, effect: me.effect });
        },
    },
};
</script>
